import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { RecipientEntityModel } from '@app/core/models/recipient-entity/recipient-entity.model';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { AdministrationBase } from '@app/features/administration/administration-base';
import { ImportReportModel } from '@app/core/models/administration/imports/import-report.model';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { takeUntil } from 'rxjs/operators';
import { RecipientEntityKeywordsComponent } from '../recipient-entity-keywords/recipient-entity-keywords.component';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';


@Component({
  selector: 'app-recipient-entity-list',
  templateUrl: './recipient-entity-list.component.html',
  styleUrls: ['./recipient-entity-list.component.scss']
})
export class RecipientEntityListComponent extends AdministrationBase<RecipientEntityModel> implements OnInit, OnDestroy {

  constructor(
    route: ActivatedRoute,
    router: Router,
    dialog: MatDialog,
    authenticationInfoService: AuthenticationInfoService,
    public recipientEntityService: RecipientEntitiesService) {
    super(dialog, router, route, authenticationInfoService);
    this.title = "SOCIETES DESTINATAIRES";
    this.subtitle ="societe destinataire";
  }

  ngOnInit(): void {
  }

  protected activateItem(id: any): Observable<any> {
    return this.recipientEntityService.activateRecipientEntity(id);
  }

  protected deactivateItem(id: any): Observable<any> {
    return this.recipientEntityService.deactivateRecipientEntity(id);
  }

  protected getDataItems(): Observable<RecipientEntityModel[]> {
    return this.recipientEntityService.getRecipientEntities();
  }

  importHandler = (files: File[]): Observable<ImportReportModel[]> => {
    return this.recipientEntityService.importRecipientEntities(files);
  };

  onSettings = () => {
    const forwardModal = new ModalHelper().getRecipientEntityKeywordsConfig();
    const dialog = this.dialog.open(RecipientEntityKeywordsComponent, forwardModal);

    return dialog.afterClosed()
      .pipe(takeUntil(this.unsubscribe$));
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  onClearFilters = (): void => {
    this.onFiltersCleared.next();
  }

  exportAsExcel() : void {
    this.onExportExcelCaller.next();
  }
}
